import { render } from "./Footer.vue?vue&type=template&id=b15161d0&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=b15161d0&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../worktrees/adel01/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b15161d0"]])

export default __exports__